
  <div class="container">

    <div *ngIf="!userService.accept" class="animated fadeIn">
      <termsofservice></termsofservice>
    </div>

    <div  class="animated fadeIn" style="max-width: 800px; margin: auto; margin-top: 50px; padding: 10px 8px 20px 8px;">

      <div *ngIf="!continue" id="loginForm" style="display: none; border: 1px solid var(--green); text-align: center">

        <div *ngIf="userService.accept">
          <div class="row" style="margin: 0">
            <div class="col-md-6" style="padding: 20px 20px 100px 20px">
              <img src="assets/img/icons/login.png" style="margin: 0 auto; height: 100px;" />
              <div style="font-size: 14px; padding: 20px;">
                <span *ngIf="!enterOtp">Enter your username and password to sign in and gain access to ONE AVBOB Connect</span>
                <span *ngIf="enterOtp">{{ enterOtp }}</span>
              </div>
              <div style="background-color: var(--green); color: #fff; padding: 20px; position: absolute; bottom: 0; left:0; right: 0">
                This is a private network. <br />Unauthorised access is prohibited
              </div>
            </div>
            <div class="col-md-6" style="background-color: rgba(22, 66, 24, 0.1); padding: 20px">

              <div *ngIf="!enterOtp">

                <mat-form-field class="mt-3">
                  <mat-label>{{ userHint }}</mat-label>
                  <input [type]="usertype" matInput [(ngModel)]="username" style="text-transform: none" focus>
                  <mat-icon matSuffix style="color: var(--brown)">person</mat-icon>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Enter your password</mat-label>
                  <input [type]="hide ? 'password' : 'text'" matInput [(ngModel)]="password" style="text-transform: none" />
                  <mat-icon matSuffix (click)="hide = !hide" style="cursor: pointer; color: var(--brown)">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                </mat-form-field>

                <div *ngIf="!continue && result" class="error mb-2 mt-2">
                  {{ result }}
                </div>

                <div *ngIf="allowRegister" style="margin-bottom: 16px">
                  <mat-checkbox [(ngModel)]="userService.accept" style="margin-right: 6px"></mat-checkbox> I agree to the <a class="link-button" (click)="showTerms()">terms of use</a>
                </div>

                <button class="button" id="btnLogin" (click)="login()" *ngIf="!getOTP" style="margin: 20px 0">CONNECT <i class="fas fa-chevron-right"></i></button>

                <a style="font-weight: 600;" *ngIf="!allowRegister" href="https://psspr01.avbob.co.za/sspr/public/forgottenpassword">RESET MY PASSWORD</a>
                <a style="font-weight: 600" *ngIf="allowRegister" routerLink="/account/register" class="mb-3">REGISTER / UPDATE MY PASSWORD</a>

              </div>

              <div *ngIf="enterOtp">

                <div class="alert" style="margin-bottom: 0">
                  <mat-form-field class="mt-3">
                    <mat-label>Enter your OTP Code</mat-label>
                    <input name="otp" matInput [(ngModel)]="otpCode" style="text-transform: none" type="number">
                    <mat-icon matSuffix style="color: var(--brown)">how_to_reg</mat-icon>
                  </mat-form-field>
                </div>

                <div class="error m-3 mt-0" *ngIf="error">
                  {{ error }}
                </div>

                <button mat-button (click)="newOtp()" class="mb-3 mr-1">REQUEST NEW OTP</button>
                <button mat-raised-button (click)="validateOTP()" color="primary" class="mb-3">CONTINUE</button>

              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="card animated fadeIn" *ngIf="continue" style="margin-top: -20px">
        <div class="card-body text-center p-3">
          <div class="spinner">Please wait while we load your profile...</div>
        </div>
      </div>
    </div>
  </div>
